import { useTranslation } from "react-i18next";
import { formatDateAndTime } from "../../../../utils";

const ChangeNoteLog = ({
  createdAt,
  value,
  updatedBy,
}: {
  createdAt: string;
  value?: string;
  updatedBy: string;
}) => {
  const { t } = useTranslation();

  // Parse the JSON string to an array
  let parsedValue = [];
  try {
    parsedValue = value ? JSON.parse(value) : [];
  } catch (error) {
    console.error("Failed to parse value:", value);
  }
  // Extract values from the array
  const oldNote = parsedValue.oldNote ? parsedValue.oldNote : null;
  const NewNote = parsedValue.NewNote ? parsedValue.NewNote : null;
  return (
    <div className="card-auto p-24 my-10 row row-column gap-8">
      <div>{formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
      <div>
        {updatedBy} {t("changed")} <strong>{t("Comment")}</strong>
      </div>
      <br /> {t("from")}
      <div>
        <br /> {oldNote}
      </div>
      <div>
        <br /> {t("to")}
      </div>
      <div>
        <br /> {NewNote} {/* New Value */}
      </div>
    </div>
  );
};

export default ChangeNoteLog;
